import language from "#scripts/translation";

export const buttonRowFront = (buttonsData, className) => {
	const buttonArray = buttonsData
		.replaceAll("&amp;", "&")
		.split(";")
		.map((x) => x.replace("}", "").split("{"));
	let buttonRow = [];
	for (const item of buttonArray) {
		let icon = "arrow_forward";
		let target = "";
		if (item.length > 1 && item[1].includes("://")) {
			icon = "open_in_new";
			target = "_blank";
		}
		const button = `
            <div>
                <a class="buttonrow__button" href="${item[1]}" title="${language("NAV_OPEN_I_NEW")}" target="${target}" rel="noopener noreferrer">
                    ${item[0]}
										<div></div>
                    <span class="material-icons-outlined notranslate buttonrow__button__icon">${icon}</span>
                </a>
            </div>`;
		buttonRow.push(button);
	}
	buttonRow = buttonRow.join("");

	return `
        <div class="buttonrow p-0 justify-content-md-center ${className}" id="buttonrow__frontpage">
            ${buttonRow}
        </div>`;
};
